import { createFileRoute } from '@tanstack/react-router';
import { SubmissionView } from '@uturn/portal/modules/document-reader';

const DocumentReaderSubmission = () => {
	const { submissionId } = Route.useParams();
	return <SubmissionView submissionId={submissionId} />;
};

export const Route = createFileRoute('/_protected/document-reader/$submissionId')({
	component: DocumentReaderSubmission,
});
